import { Avatar, Grid } from '@mui/material';
import { MEDICINE_STATUSES, Statuses } from 'API';
import { useIsDesktop } from 'Hooks';
import { StepIcon1, StepIcon2, StepIcon3, StepIcon4 } from 'Images';
import parse from 'html-react-parser';

interface IEquipmentStatusExtraInfoProps {
  stepStatus: Statuses;
}

export const MedicineStatusExtraInfo = ({
  stepStatus,
}: IEquipmentStatusExtraInfoProps) => {
  const isDesktop = useIsDesktop();

  const getIcon = (status: number) => {
    switch (status) {
      case MEDICINE_STATUSES.WAITING_TO_OPEN_IN_SYSTEM:
      case MEDICINE_STATUSES.OPEN_IN_SYSTEM:
      case MEDICINE_STATUSES.WING_HANDLING:
      case MEDICINE_STATUSES.MANUAL_PRESCRIPTION_THAT_APPROVED_AND_ISSUED:
      case MEDICINE_STATUSES.SUPERPHARM_HANDLING:
        return (
          <Avatar
            src={StepIcon1}
            sx={{ width: '70px', height: '60px', mb: 2 }}
            alt=''
          />
        );

      case MEDICINE_STATUSES.SUPERPHARM_FULL_SUPPLY:
        return (
          <Avatar
            src={StepIcon3}
            sx={{ width: '100px', height: '69px', mb: 2 }}
            alt=''
          />
        );

      case MEDICINE_STATUSES.REJECTED:
      case MEDICINE_STATUSES.SUPERPHARM_SUPPLY_STOPPED:
        return (
          <Avatar
            src={StepIcon2}
            sx={{ width: '66px', height: '65px', mb: 2 }}
            alt=''
          />
        );

      case MEDICINE_STATUSES.SUPERPHARM_PARTIAL_SUPPLY:
        return (
          <Avatar
            src={StepIcon4}
            sx={{ width: '85px', height: '58px' }}
            alt=''
          />
        );
    }
  };

  return (
    <Grid
      container
      direction={'column'}
      sx={{
        backgroundColor: 'primary.shade_50',
        border: '1px solid',
        borderColor: 'primary.shade_200',
        padding: isDesktop ? '40px 24px' : '24px 15px',
        borderRadius: '16px',
        alignItems: 'center',
        m: 0,
        maxWidth: '600px',
        mb: '40px',
      }}
    >
      {getIcon(stepStatus.calcStatus)}
      {parse(stepStatus.description || '')}
    </Grid>
  );
};
